import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import TextField from '../../plugins/text-field/text-field';
import TextField2 from '../../plugins/text-field/text-field-2';
import VDialog from 'vuetify/src/components/VDialog';
import AddField from './add-field';

import { EventHooks } from '../../plugins/text-field';
import { isEnterKey, wait, waitForAnimation } from '../../utility';
import { watchQueryModal } from '../modal/modal.mixin';
import { FieldService } from './field.service';
import DBox from '../dbox/dbox';
import { isEnterkey } from '../../utility/index';

@Component
export default class CustomField extends Vue {
  @Prop() fields;

  @Prop({ required: true }) externalTable;
  @Prop({}) hint;
  @Prop({}) externalId;
  @Prop({}) section;
  @Prop({}) module;
  @Prop({ default: false }) disabled;


  get fieldAddable() {
    return this.section && this.externalId && this.module;
  }


  textFieldConfig = {
    height: 42,
    showEditIconOnHover: false,
    box: true,
    showValidationIcons: false,

    validationEvent: EventHooks.OnBlur,
    valueChangedEvent: EventHooks.OnBlur,
  };

  addFieldRoute = 'add_field';
  addFieldModalContainer = false;
  addFieldModal = false;


  addFieldFlag = false;
  addFieldLoadingFlag = false;
  newFieldLabel = '';


  modalQueryWatcher = watchQueryModal(this.addFieldRoute, 'addFieldModalContainer', 'addFieldModal');

  @Watch('$route', { immediate: true }) routeWatch(to, from) {
    this.modalQueryWatcher(to, from, this);
  }

  async onTextFieldValueChange({ name, value }) {

    await FieldService.updateField({
      kVal: name,
      value
    });
    if (this.externalTable == 'artist') {
      console.log("TTYU")
      this.$emit('changed', {
        name,
        value,
        edit: true
      })
    } else {

      this.$emit('changed', this.fields.map(f => {
        if (f.custom_data_id == name) {
          return {
            ...f,
            data: value,
          };
        } else {
          return f;
        }
      }));
    }


  }
  addCustomField() {
    this.$router.push({
      ...this.$route,
      query: {
        modal: 'add_field'
      }
    });
  }
  onAddFieldCancel() {
    this.$router.push({
      ...this.$route,
      query: {
        modal: undefined
      }
    });
  }

  scrollToBottom() {
    this.$refs["customFieldsContainer"].scrollTop = this.$refs["customFieldsContainer"].scrollHeight;
  }

  async addFieldClick() {
    this.addFieldFlag = true;
    console.log(this.$refs["customFieldsContainer"].scrollHeight);

    setTimeout(() => {
      this.scrollToBottom();
      this.$refs['newFieldInput'].$el.lastElementChild.focus();
      console.log(this.$refs['newFieldInput']);

    }, 20);
  }
  async onNewFieldLabelChange({ name, value }) {
    this.newFieldLabel = value;
  }
  async onEnter() {
    // console.log('New Field to be Added', this.newFieldLabel);
    this.addFieldLoadingFlag = true;
    // await wait(900);
    await this.onAddField({ fieldLabel: this.newFieldLabel });

    this.addFieldLoadingFlag = false;
    this.addFieldFlag = false;
    this.newFieldLabel = '';

    await wait(20);
    this.scrollToBottom();
  }

  async onAddField(field) {
    const { fieldLabel } = field;
    await FieldService.insertField({
      field_label: fieldLabel,
      external_table: this.externalTable
    });
    const fields = await FieldService.findFields({
      moduleURL: `/${this.module}.pl`,
      external_id: this.externalId,
      external_table: this.externalTable,
      section: this.section
    });
    this.onAddFieldCancel();
    this.$emit('changed', fields.data);
  }


  render(createElement) {
    return (
      <DBox
        id={'cmp-dtplugins-groups'}
        addButton={false}
        addLink={this.fieldAddable
          ? (this.addFieldFlag ? false : true)
          : false
        }
        addLinkLabel={`${this.$t('add_custom_field')}`}
        onAddClick={this.addFieldClick}
        topRightMenu={this.hint ? [
          {
            html: this.hint,
            icon: 'Help2.svg',
            value: 'question',
            cardStyle: {
              width: '300px'
            }
          },
        ] : []}
      >
        <div class="ut-fc hoverFC2Gray" ref={"customFieldsContainer"} style={{
          height: this.addFieldFlag ? `calc(100% - 40px)` : `100%`,
          overflowY: `auto`,
          borderBottom: '1px solid var(--sprt-85)',
        }}>
          {this.fields && this.fields.length > 0 && this.fields.map((field, index) => {
            return (
              <TextField2
                key={field.custom_data_id}
                id={`${field.custom_data_id}`}
                value={field.data}
                placeholder={`Enter ${field.field_label}`}
                label={field.field_label}
                lw="200px"
                bb={(index == this.fields.length - 1 && !this.addFieldFlag) ? 'none' : undefined}
                onChange={this.onTextFieldValueChange}
                disabled={this.disabled}
              />
            );
          })}
          {this.addFieldFlag && <div class="ut-flex" style={{
            borderBottom: '1px solid var(--sprt-85)',
          }}>
            <TextField2
              style={{
                width: '215px',
              }}
              id={`new_field`}
              value={this.newFieldLabel}
              disabled={this.addFieldLoadingFlag}
              placeholder={`Enter New Label Name`}
              showLabel={false}
              ref="newFieldInput"
              onChange={this.onNewFieldLabelChange}
              bb="none"
              onEnter={this.onEnter}
            />
            {!this.addFieldLoadingFlag && <button class="dt-button v5 h22p" style={{
              margin: 'auto 14px'
            }}
              onClick={this.onEnter}
            >Confirm</button>}
            {this.addFieldLoadingFlag && <button class="dt-button v5 h22p" style={{
              margin: 'auto 14px'
            }}>
              <img src="static/icons/loading.gif" alt />
            </button>}
          </div>}
        </div>
        {this.addFieldFlag && <div style={{
          height: '40px',
          display: 'flex',
        }}>
          <div style={{
            margin: 'auto 8px',
          }} class="ut-font-small ut-text-secondary">
            Finish process to add new Custom Fields
          </div>
        </div>}

        {this.addFieldModalContainer &&
          <VDialog
            vModel={this.addFieldModal}
            persistent={true}
            width="400"
          >
            <AddField
              onAdded={this.onAddField}
              onCancelled={this.onAddFieldCancel}
            >

            </AddField>
          </VDialog>
        }
      </DBox>
    );
  }
};
